import { buildFormDataFromTeamMember } from '@/utils/teamRegistration/fieldMapping';
import type { TeamRegistrationField } from '@/types/tournament/game';
import type { PhoneData } from '@/types/tournament/quickRegistration';
import type { TeamMember } from '@/types/team';

/**
 * Initial form state for editing a roster member’s registration fields (PUT /team/:teamId/member body: { role, fields }).
 * Merges join-style defaults (empty / user fallbacks) with values from the existing `TeamMember`.
 */
export function buildTeamMemberDetailsEditFormState(
  joinFlowDefaults: Record<string, string | PhoneData>,
  rosterMember: TeamMember,
  registrationFields: TeamRegistrationField[],
): Record<string, string | PhoneData> {
  const fromMember = buildFormDataFromTeamMember(
    rosterMember,
    registrationFields,
  );
  const merged: Record<string, string | PhoneData> = { ...joinFlowDefaults };

  for (const field of registrationFields) {
    const key = field.fieldKey;
    if (!(key in fromMember)) continue;
    const v = fromMember[key];
    if (key === 'mobileNo' && typeof v === 'object' && v && 'number' in v) {
      const def = joinFlowDefaults[key] as PhoneData;
      merged[key] = {
        ...def,
        ...v,
        code: v.code || def.code,
        number: v.number ?? def.number,
      };
    } else {
      merged[key] = v;
    }
  }

  return merged;
}
